import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

export default function RequireAuth({ children }) {
  const loc = useLocation();
  const nav = useNavigate();
  // Consume ?token=... from URL BEFORE guarding (bookmarkable magic-link support)
  const params = new URLSearchParams(loc.search);
  const urlToken = params.get("token");

  useEffect(() => {
    if (!urlToken) return;
    localStorage.setItem("joh_admin_token", urlToken);
    // Strip ?token= uit de URL: browser-terug mag geen verlopen token over de verse sessie heen zetten
    params.delete("token");
    const rest = params.toString();
    nav({ pathname: loc.pathname, search: rest ? `?${rest}` : "" }, { replace: true });
  }, [urlToken]); // eslint-disable-line

  const token = urlToken || localStorage.getItem("joh_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}
